var _ = require("lodash");

var
  C = require("./Constructors"),
  Var         = C.Var,
  Application = C.Application,
  Lambda      = C.Lambda,
  External    = C.External;

var
  Externals = require("./Externals"),
  ExternalObjectInterpretation = Externals.ExternalObjectInterpretation,
  getExternalTraverse = Externals.getExternalTraverse;

/**
 * `FreeVar(term)` returns an array of term's free variables.
 * Each variable may appear more that once in the array.
 * @summary free variables
 * @param {LambdaTerm} term - a lambda term
 * @return an array of term's free variables
 * @memberof module:Lambda/FreeVar
 */
function FreeVar(term) {
  if(term instanceof Var)
    return [term];
  if(term instanceof Application)
    return _.concat(FreeVar(term.func), FreeVar(term.arg));
  if(term instanceof Lambda)
    return _.without(FreeVar(term.body), term.arg);
  if(term instanceof External) {
    //TODO: check this block and delete it if it is redundant
    if(term.objType === undefined) {
      console.warn(term);
      throw "objType undefined!";
    }
    //TODO: replace this block with External getters
    if(ExternalObjectInterpretation[term.objType] === undefined) {
      console.warn(term);
      console.warn("interpretation is not implemented");
      return [];
    }
    var traverse = getExternalTraverse(term.objType);
    return _.uniq(_.flatten(traverse(term.object, FreeVar)));
  }
  throw "an argument " + term + " is not a term";
}

module.exports = FreeVar;
